export enum RouteTypes {
  APP = 'app',
  CREATE = 'create',
  DETAILS = 'details',
  LISTING = 'listing',
  DASHBOARD = 'dashboard',
  MODULE = 'module',
}
